import React from "react";
import { formatNumber, percentageFormat } from "../../../../../Utils/utils";

interface OriginalDataCardProps {
  selectedModality: any;
  data: any;
}

const OriginalDataCard = ({ selectedModality, data }: OriginalDataCardProps) => {
  const findOriginalModality = () => {
    if (!data.producto || !Array.isArray(data.producto)) {
      return null;
    }
    const modalityToMatch = selectedModality.id
      ? selectedModality
      : data.modalidadRecalculada;

    if (!modalityToMatch || !modalityToMatch.id) {
      return null;
    }

    const matchedProduct = data.producto.find((producto: any) => {
      return producto.id === modalityToMatch.id;
    });

    return matchedProduct;
  };

  const originalProduct = findOriginalModality();
  const originalPrimaCia = originalProduct && originalProduct.respuestaMacro
    ? originalProduct.respuestaMacro.primaCia
    : null;

  return (
    <div className="card-verify ">
      <div className="card-verify__header">
        <div
          className="card-verify__title"
          style={{ fontSize: "14px", fontWeight: "bold" }}
        >
          VALORES ORIGINALES (Antes del Recálculo)
        </div>
      </div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Capital Pensión</div>
          <div className="card-verify__data">
            {data.fondo && data.fondo.capitalPension
              ? formatNumber.new(data.fondo.capitalPension)
              : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Prima Única AFP</div>
          <div className="card-verify__data">
            {selectedModality.respuestaMacro &&
              selectedModality.respuestaMacro.primaAfp
              ? formatNumber.new(selectedModality.respuestaMacro.primaAfp)
              : data.modalidadRecalculada.respuestaMacro &&
                data.modalidadRecalculada.respuestaMacro.primaAfp
                ? formatNumber.new(
                  data.modalidadRecalculada.respuestaMacro.primaAfp
                )
                : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">CIC</div>
          <div className="card-verify__data">
            {originalPrimaCia
              ? formatNumber.new(originalPrimaCia)
              : "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Cesión Comisión</div>
          <div className="card-verify__data">
            {(selectedModality.respuestaMacro &&
              selectedModality.respuestaMacro.cesionComision) ||
              (data.modalidadRecalculada.respuestaMacro &&
                data.modalidadRecalculada.respuestaMacro.cesionComision) ||
              "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">TIR(%)</div>
          <div className="card-verify__data">
            {(selectedModality.respuestaMacro &&
              percentageFormat(selectedModality.respuestaMacro.tir)) ||
              (data.modalidadRecalculada.respuestaMacro &&
                percentageFormat(
                  data.modalidadRecalculada.respuestaMacro.tir
                )) ||
              "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">VAN</div>
          <div className="card-verify__data">
            {(selectedModality.respuestaMacro &&
              formatNumber.new(selectedModality.respuestaMacro.van)) ||
              (data.modalidadRecalculada.respuestaMacro &&
                formatNumber.new(
                  data.modalidadRecalculada.respuestaMacro.van
                )) ||
              "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Renta Vitalicia</div>
          <div className="card-verify__data">
            {selectedModality.respuestaMacro &&
              selectedModality.respuestaMacro.primaPensionRv
              ? formatNumber.new(selectedModality.respuestaMacro.primaPensionRv)
              : data.modalidadRecalculada.respuestaMacro &&
                data.modalidadRecalculada.respuestaMacro.primaPensionRv
                ? formatNumber.new(
                  data.modalidadRecalculada.respuestaMacro.primaPensionRv
                )
                : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Renta Temporal</div>
          <div className="card-verify__data">
            {selectedModality.respuestaMacro &&
              selectedModality.respuestaMacro.primaPensionRt
              ? formatNumber.new(selectedModality.respuestaMacro.primaPensionRt)
              : data.modalidadRecalculada.respuestaMacro &&
                data.modalidadRecalculada.respuestaMacro.primaPensionRt
                ? formatNumber.new(
                  data.modalidadRecalculada.respuestaMacro.primaPensionRt
                )
                : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Gasto de Sepelio</div>
          <div className="card-verify__data">
            {selectedModality.respuestaMacro &&
              selectedModality.respuestaMacro.gastoSepelio
              ? formatNumber.new(selectedModality.respuestaMacro.gastoSepelio)
              : data.modalidadRecalculada.respuestaMacro &&
                data.modalidadRecalculada.respuestaMacro.gastoSepelio
                ? formatNumber.new(
                  data.modalidadRecalculada.respuestaMacro.gastoSepelio
                )
                : "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line" />
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Tipo de Cambio</div>
          <div className="card-verify__data">
            {data && data.tipoCambio || '0'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OriginalDataCard;
